export const navigation = [
    {
        title: 'Reservations',
        icon: 'date_range',
        path: 'reservations'
    },
    {
        title: 'Users',
        icon: 'person',
        path: 'users'
    }
]


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/_navigation.ts